export const tableProvider = {
  IS_HOVERABLE: Symbol(),
  VERTICAL_ALIGN: Symbol(),
  COLLAPSE_DIRECTIONS: Symbol(),
};
